/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const VoiceOverIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Voice Over',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M23.8 7.2a6.8 6.8 0 0 0-13.6 0v13.6a6.8 6.8 0 1 0 13.6 0Z" />
    <path
      d="M28 21v-4.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V21a9 9 0 1 1-18 0v-4.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V21c0 5.725 5.357 11 10 11v2H8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H18v-2.058c4.643 0 10-5.216 10-10.942Z"
    />
  </svg>`;
};
